import useScrollToTop from "hooks/useScrollToTop";
import Button from "../../../../Components/Common/Button/Button";

const deliveryLabel: Record<string, string> = {
  email_platform: "Email + In-app",
  platform: "In-app only",
  email: "Email only",
};

interface SuccessScreenProps {
  onRestart: () => void;
  onViewProject: () => void;
  onDownload: () => void;
  reportNum?: number | string;
  prefill?: { project?: { name?: string } };
  lenderName?: string;
  lendingOfficer?: string;
  ownerName?: string;
  gcName?: string;
  deliveryMethod?: string;
  deliveryCc?: string[];
  invoiceNumber?: string;
  invoiceAmount?: string;
}

const SuccessScreen = ({
  onRestart,
  onViewProject,
  onDownload,
  reportNum,
  prefill,
  lenderName,
  lendingOfficer,
  ownerName,
  gcName,
  deliveryMethod = "email_platform",
  deliveryCc,
  invoiceNumber,
  invoiceAmount,
}: SuccessScreenProps) => {
  useScrollToTop("success", { skipFirstRender: false });
  const project = prefill?.project;
  const displayProject = project?.name || "this project";
  const method = deliveryLabel[deliveryMethod] ?? deliveryMethod;

  const deliveryRows: string[] = [
    lendingOfficer && lenderName
      ? `${lendingOfficer} — ${lenderName} (${method})`
      : lenderName
        ? `${lenderName} (${method})`
        : null,
    ownerName ? `${ownerName} — Owner Portal (In-app)` : null,
    gcName ? `${gcName} — GC Portal (In-app)` : null,
    deliveryCc?.length ? `${deliveryCc.join(", ")} — CC` : null,
    invoiceNumber || invoiceAmount
      ? [
          "CSC Invoice",
          invoiceNumber
            ? invoiceNumber.startsWith("#")
              ? invoiceNumber
              : `#${invoiceNumber}`
            : null,
          invoiceAmount ? `$${invoiceAmount}` : null,
          "generated and attached",
        ]
          .filter(Boolean)
          .join(" — ")
      : null,
  ].filter((r): r is string => Boolean(r));

  return (
    <div className="craSuccess">
      <div className="craSuccess__icon">📄</div>
      <h2>Report {reportNum ?? ""} Published</h2>
      <p>
        Construction Progress Report{reportNum ? ` ${reportNum}` : ""} for{" "}
        {displayProject} has been published and delivered. The report is now
        locked and visible to authorized parties in the project portal.
      </p>
      {deliveryRows.length > 0 && (
        <div className="craSuccess__list">
          <h4>Delivered To</h4>
          {deliveryRows.map((item, i) => (
            <div key={i} className="item-row">
              <span>✓</span>
              <span>{item}</span>
            </div>
          ))}
        </div>
      )}
      <div className="craSuccess__actions">
        <Button className="btnPrimary" onClick={onViewProject}>
          View Project
        </Button>
        <Button className="btnSecondary" onClick={onDownload}>
          Download PDF
        </Button>
        <Button className="btnSecondary" onClick={onViewProject}>
          Author Another Report
        </Button>
      </div>
    </div>
  );
};

export default SuccessScreen;
